<template>
    <v-app> 
         <Tabs :routes='route' colors="#2060d3" />
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
            <Menu type="conductores"/>
    </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import Menu from '../../component/layouts/single'

export default {
    components:{
        Tabs,
        Menu
    },

    mounted() {
        this.GetConductor();
    },

    methods: {
        GetConductor:function(){
            this.$store.dispatch('LoadingAction');
            this.$store.dispatch('GetDrivings');
        }
    },

    

    data(){
        return {

            route:[
                {
                    id:1,
                    name:'Lista de conductores',
                    icon:'mdi-table-large',
                    route:'/conductor',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Conductor',
                        disabled: true,
                        href: 'conductor',
                        },
                        
                    ],
                
                },

                {
                    id:2,
                    name:'Crear conductor',
                    icon:'mdi-clipboard-account',
                    route:'/conductor/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Conductor',
                        disabled: false,
                        href: '/conductor',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/conductor/crear',
                        },
                        
                    ],

                },
            ]

        }
    }

  }
</script>